module.exports = __webpack_public_path__ + "img/descSort.7bb899d8.svg";